import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class SchedulePreference extends Vue
{
    @Prop() dayOfWeekId!: number;
    @Prop() dayOfWeek!: string;
    @Prop() avaliablity!: string;
    @Prop() preference!:  boolean;
    @Prop() effectiveDate!: Date;
    @Prop() expiryDate!: Date;    	
}
